"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = banners;
exports.initialState = void 0;
var _types = require("../../actions/banner/types");
var _types2 = require("../../actions/broadcast/types");
var _types3 = require("../../actions/program/types");
var _types4 = require("../../actions/types/types.generic");
var initialState = exports.initialState = [];
function banners() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var type = action.type,
    payload = action.payload;
  if (["".concat(_types2.GET_BROADCAST, "_SUCCESS"), _types.BROADCAST_SYNC_BANNERS_STATUS, "".concat(_types3.BROADCAST_SET_PROGRAM, "_SUCCESS"), "".concat(_types4.BROADCAST_SYNC_BANNERS, "_SUCCESS"), "".concat(_types4.BROADCAST_SYNC_LAYER_SOURCES, "_SUCCESS")].includes(type)) {
    var _banners = payload.banners;
    if (_banners) return _banners;
  } else if (type === "".concat(_types4.BROADCAST_CREATE_BANNER, "_SUCCESS") || type === "".concat(_types4.BROADCAST_UPDATE_BANNER, "_SUCCESS") || type === "".concat(_types4.BROADCAST_DELETE_BANNER, "_SUCCESS") || type === "".concat(_types4.BROADCAST_DUPLICATE_BANNER, "_SUCCESS") || type === _types.UPDATE_BANNER || type === "".concat(_types.BROADCAST_TOGGLE_BANNER_HIDDEN, "_SUCCESS")) {
    return payload;
  }
  return state;
}